import Axios from 'axios';

// Axios.defaults.baseURL = 'https://flight.musafirbazar.com/api/';
Axios.defaults.baseURL = 'https://newinv.musafirbazar.com/apiC/';

export const axiosInstance = Axios.create({});
